export default (file, allowedSize) => {
  if (file && file.size) {
    const sizeInMb = file.size / 1024 / 1024;
    if (sizeInMb <= allowedSize) {
      return true;
    }
  }
  return false;
};
